/**
 * bunny.net Stream Analytics API
 * Metrics come from data sources with different prerequisites: some need only standard CDN request logging, others need CMCD v1 query-string enrichment or a CMCD v2 player beacon - see each endpoint\'s description for which. If its required source isn\'t enabled, an endpoint returns empty/zero results, not an error.
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { HttpClient, HttpContext, HttpEvent, HttpHeaders, HttpParameterCodec, HttpParams, HttpResponse } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';

import { Observable } from 'rxjs';

import { Configuration } from '../configuration';
import { CustomHttpParameterCodec } from '../encoder';
// @ts-ignore
import { StreamAnalyticsCmcdPostPullZoneIdParameter } from '../model/stream-analytics-cmcd-post-pull-zone-id-parameter';
// @ts-ignore
import { BASE_PATH } from '../variables';

export interface StreamAnalyticsCmcdPostRequestParams {
  pullZoneId: StreamAnalyticsCmcdPostPullZoneIdParameter;
  body: string;
  videoLibraryId?: StreamAnalyticsCmcdPostPullZoneIdParameter;
  cid?: string;
  contentType?: string;
}

@Injectable({
  providedIn: 'root',
})
export class CMCDService {
  protected basePath = 'https://mc-cwlfiqxct9.bunny.run';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration,
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== 'string') {
      const firstBasePath = Array.isArray(basePath) ? basePath[0] : undefined;
      if (firstBasePath != undefined) {
        basePath = firstBasePath;
      }

      if (typeof basePath !== 'string') {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }

  // @ts-ignore
  private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
    if (typeof value === 'object' && value instanceof Date === false) {
      httpParams = this.addToHttpParamsRecursive(httpParams, value);
    } else {
      httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
    }
    return httpParams;
  }

  private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
    if (value == null) {
      return httpParams;
    }

    if (typeof value === 'object') {
      if (Array.isArray(value)) {
        (value as any[]).forEach((elem) => (httpParams = this.addToHttpParamsRecursive(httpParams, elem, key)));
      } else if (value instanceof Date) {
        if (key != null) {
          httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
        } else {
          throw Error('key may not be null if value is Date');
        }
      } else {
        Object.keys(value).forEach((k) => (httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k)));
      }
    } else if (key != null) {
      httpParams = httpParams.append(key, value);
    } else {
      throw Error('key may not be null if value is not object or array');
    }
    return httpParams;
  }

  /**
   * Accept CMCD v2 Event Mode reports
   * Public beacon endpoint for CMCD v2 (CTA-5004-B) Event Mode reports. Body must be Content-Type \&#39;application/cmcd\&#39;: one or more CMCD records joined by a single LF, exactly as any CMCD v2-compliant reporter (e.g. hls.js\&#39;s cmcd.eventTargets) sends them. pullZoneId is required; videoLibraryId, cid (the video ID) and contentType (\&#39;live\&#39; or \&#39;vod\&#39;) are optional extra context. A 429 can mean either the caller is rate-limited or the server\&#39;s internal event buffer is temporarily full - either way, back off and retry.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public streamAnalyticsCmcdPost(
    requestParameters?: StreamAnalyticsCmcdPostRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any>;
  public streamAnalyticsCmcdPost(
    requestParameters?: StreamAnalyticsCmcdPostRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<any>>;
  public streamAnalyticsCmcdPost(
    requestParameters?: StreamAnalyticsCmcdPostRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<any>>;
  public streamAnalyticsCmcdPost(
    requestParameters?: StreamAnalyticsCmcdPostRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    const pullZoneId = requestParameters?.pullZoneId;
    if (pullZoneId === null || pullZoneId === undefined) {
      throw new Error('Required parameter pullZoneId was null or undefined when calling streamAnalyticsCmcdPost.');
    }
    const body = requestParameters?.body;
    if (body === null || body === undefined) {
      throw new Error('Required parameter body was null or undefined when calling streamAnalyticsCmcdPost.');
    }
    const videoLibraryId = requestParameters?.videoLibraryId;
    const cid = requestParameters?.cid;
    const contentType = requestParameters?.contentType;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (pullZoneId !== undefined && pullZoneId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pullZoneId, 'pullZoneId');
    }
    if (videoLibraryId !== undefined && videoLibraryId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>videoLibraryId, 'videoLibraryId');
    }
    if (cid !== undefined && cid !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>cid, 'cid');
    }
    if (contentType !== undefined && contentType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>contentType, 'contentType');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/cmcd'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/stream/analytics/cmcd`;
    return this.httpClient.request<any>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: body,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }
}
